import React, { useRef, useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, Form } from "react-bootstrap";
import UserImg from "../../assets/images/providerProfileImg.png";
import { AttachedIcon, BackIcon, BlockIcon, PapperBoatIcon } from "../Icons";
import { MdCalendarToday, MdAccessTime, MdAttachMoney } from "react-icons/md";
import socket from "../../socket/socket";
import { audioBlobToBase64, convertToMp3, fetchImage, getFullName } from "../../utils/common";
import {
  blockUser,
  fetchBlockStatus,
  unblockUser,
} from "../../services/hireProvider.service";
import { setLoader } from "../../slice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../slice/authSlice";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import "./Newchat.scss";
import VoiceMsg from "./VoiceMsg";
import { createJobFromOffer } from "../../services/auth.service";
import CreateOfferPaymentModal from "../../modals/payment/CreateOfferPaymentModal";

const Newchat = (props) => {
  const user = useSelector(selectUser);
  const userType = user?.userType;
  const [message, setMessge] = useState([]);
  const [input, setInput] = useState("");
  const [imageData, setImageData] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [sendingImage, setSendingImage] = useState(false);

  const loggedInuser = localStorage.getItem("users");
  const { id } = JSON.parse(loggedInuser);
  const scrollRef = useRef(null);
  const dispatch = useDispatch();
  const [blockedStatus, setBlockedStatus] = useState([]);
  const [blockedStatusBySender, setBlockedStatusBySender] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  const [fetchedImages, setFetchedImages] = useState({});
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [voiceNote, setVoiceNote] = useState(null);
  const openEnlargedView = (image) => setEnlargedImage(image);
  const closeEnlargedView = () => setEnlargedImage(null);
  const [fetchedAudios, setFetchedAudios] = useState({});
  const [loadingOfferId, setLoadingOfferId] = useState(null);
  const [paymentModal, setPaymentModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [selectedOfferModal, setSelectedOfferModal] = useState(null)

  useEffect(() => {
    const loadImage = async () => {
      if (props?.showChat?.profilePic) {
        try {
          const fetchedImage = await fetchImage(props.showChat.profilePic);
          setProfileImage(fetchedImage);
        } catch (error) {
          setProfileImage(UserImg);
        }
      } else {
        setProfileImage(UserImg);
      }
    };
    loadImage();
  }, [props?.showChat?.profilePic]);

 useEffect(() => {
  const fetchMedia = async () => {
    const imagePromises = [];
    const audioPromises = [];

    message.forEach((msg) => {
      if (msg?.type === "image" && msg?.image) {
        imagePromises.push(
          fetchImage(msg.image).then((url) => ({ id: msg._id, url })).catch(() => ({ id: msg._id, url: UserImg }))
        );
      } else if (msg?.type === "audio" && msg?.audio) {
        audioPromises.push(
          fetchImage(msg.audio).then((url) => ({ id: msg._id, url })).catch(() => null)
        );
      }
    });

    const [imageResults, audioResults] = await Promise.all([
      Promise.all(imagePromises),
      Promise.all(audioPromises),
    ]);

    const imageMap = {};
    imageResults.forEach((img) => {
      if (img) imageMap[img.id] = img.url;
    });

    const audioMap = {};
    audioResults.forEach((aud) => {
      if (aud) audioMap[aud.id] = aud.url;
    });

    setFetchedImages(imageMap);
    setFetchedAudios(audioMap);
  };

  if (message.length) fetchMedia();
}, [message]);


  useEffect(() => {
    if (!props.showChat?._id) return;

    const isHelpChat = props.showChat.isHelpChat;
    
    const handleMessageData = (ele) => {
      if (Array.isArray(ele) && ele.length > 0) {
        const msgRoomId = ele[0].roomID || ele[0].chatId;
  
        if (msgRoomId === props.showChat._id) {
           setMessge(ele);
        } else if (!msgRoomId) {
           setMessge(ele);
        }
      } else if (Array.isArray(ele) && ele.length === 0) {
        setMessge([]);
      }
    };

    const handleLiveUpdate = (ele) => {
        if (ele && ele.length > 0 && ele[0].roomID === props.showChat._id) {
            setMessge(ele);
        }
    };

    if (isHelpChat) {
        socket.emit("get-all-user-help-messages", props.showChat);
        socket.on("user-help-chat-message", handleMessageData); 
        socket.on("user-help-chat-message2", handleLiveUpdate);

    } else {
        socket.emit("get_All_Messages", props.showChat);
        socket.on("chat-message", handleMessageData); 
        socket.on("chat-message2", handleLiveUpdate);
    }

    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;

    return () => {
        socket.off("user-help-chat-message", handleMessageData);
        socket.off("user-help-chat-message2", handleLiveUpdate);
        socket.off("chat-message", handleMessageData);
        socket.off("chat-message2", handleLiveUpdate);
    };
  }, [props.showChat]);

  useEffect(() => {
    if (scrollRef.current)
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [message]);

  const getBlockStatus = async () => {
    try {
      await dispatch(setLoader(true));
      const response = await fetchBlockStatus({ chatId: props?.showChat?._id });
      if (response?.status) {
        const blocked = response.data.chat.blockedUsers;
        setBlockedStatus(blocked.filter((b) => b.blockedBy === id));
        setBlockedStatusBySender(blocked.filter((b) => b.blockedBy !== id));
      }
      await dispatch(setLoader(false));
    } catch (err) {
      await dispatch(setLoader(false));
    }
  };

  const containsMobileNumber = (inputString) => {
    const mobilePattern =
      /(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/;
    return mobilePattern.test(inputString);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSendingImage(true);

    const options = {
      maxSizeMB: 5,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageData(reader.result);
        setPreviewImage(reader.result);
        setSendingImage(false);
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      toast.error("Image processing failed.");
      setSendingImage(false);
    }
  };


  const sendVoiceMessage = (audioFileContent = null) => {
    if (!input && !imageData && !audioFileContent) return;

    if (input && containsMobileNumber(input)) {
      toast.warning("This message is prohibited for sending.");
      return;
    }

    let type = "text";
    let messageContent = input;
    let image = null;

    if (audioFileContent) {
      type = "audio";
      messageContent = null;
    } else if (imageData) {
      type = "image";
      messageContent = null;
      image = imageData;
    }

    const data = {
      roomID: props.showChat._id,
      message: messageContent,
      senderID: id,
      receiversID: props.showChat.reciverID,
      type,
      image: input ? null : imageData,
      userType,
      audioFile: audioFileContent || null,
    };

    if (props.showChat.isHelpChat) {
        socket.emit("send-user-help-message", data);
    } else {
        socket.emit("send-new-message", data);
    }

    setInput("");
    setImageData(null);
    setPreviewImage(null);

    setVoiceNote(null);
  };

  const sendMessage = () => {
    if (!input && !imageData) return;
    if (input && containsMobileNumber(input)) {
      toast.warning("This message is prohibited for sending.");
      return;
    }

    const data = {
      roomID: props.showChat._id,
      message: input,
      senderID: id,
      receiversID: props.showChat.reciverID,
      type: input ? "text" : "image",
      image: input ? null : imageData,
      userType,
    };

    if (props.showChat.isHelpChat) {
        socket.emit("send-user-help-message", data);
    } else {
        socket.emit("send-new-message", data);
    }

    setInput("");
    setImageData(null);
    setPreviewImage(null);

    setVoiceNote(null);
  };

  const sendText = (e) => {
    const code = e.keyCode || e.which;
    if (!input) return;
    if (code === 13) sendMessage();
  };

  const fetchBlockUser = async () => {
    try {
      await dispatch(setLoader(true));
      await blockUser({
        chatId: props?.showChat?._id,
        blockingUserId: id,
        blockedUserId: props?.showChat?.reciverID,
      });
      toast.success("User blocked.");
      getBlockStatus();
      await dispatch(setLoader(false));
    } catch {
      await dispatch(setLoader(false));
    }
  };

  const fetchUnblockUser = async () => {
    try {
      await dispatch(setLoader(true));
      await unblockUser({
        chatId: props?.showChat?._id,
        unblockingUserId: id,
        unblockedUserId: props?.showChat?.reciverID,
      });
      toast.success("User unblocked.");
      getBlockStatus();
      await dispatch(setLoader(false));
    } catch {
      await dispatch(setLoader(false));
    }
  };

  const handleAcceptOffer = (msg) => {
    if (msg?.offer?.offerStatus === "accepted") return;
    if (loadingOfferId) return;

    setLoadingOfferId(msg._id);
    setSelectedOffer(msg);
    setPaymentModal(true);
    setSelectedOfferModal(null);
  };

  const handleCancelPayment = () => {
    setPaymentModal(false);
    setLoadingOfferId(null);
    setSelectedOffer(null);
  };
  
  const normalizeTime = (time) => {
    if (!time || typeof time !== "string") return null;

    const trimmed = time.trim();

    // Case 1: Already HH:mm (24-hour)
    if (/^\d{2}:\d{2}$/.test(trimmed)) {
      return trimmed;
    }

    // Case 2: hh:mm AM/PM (possibly already 24h)
    if (/^\d{1,2}:\d{2}\s?(AM|PM)$/i.test(trimmed)) {
      const [timePart, meridian] = trimmed.split(" ");
      let [hours, minutes] = timePart.split(":");

      hours = parseInt(hours, 10);
      if (meridian.toUpperCase() === "PM" && hours < 12) {
        hours += 12;
      }
      if (meridian.toUpperCase() === "AM" && hours === 12) {
        hours = 0;
      }

      if (hours > 23) return null;

      return `${hours.toString().padStart(2, "0")}:${minutes}`;
    }

    // Case 3: ISO / Date string
    const d = new Date(trimmed);
    if (!isNaN(d)) {
      return d.toISOString().substring(11, 16);
    }

    return null;
  };
  
  const handleCardSelected = async (paymentProfileId) => {
    if (!selectedOffer) {
      toast.error("Offer data missing");
      setLoadingOfferId(null);
      return;
    }

    try {
      const date = selectedOffer.offer?.date;
      const time = normalizeTime(selectedOffer.offer?.time);

      if (!date || !time) {
        throw new Error("Invalid date or time");
      }

      const startTime = new Date(`${date}T${time}:00`);
      if (isNaN(startTime.getTime())) {
        throw new Error("Invalid Date");
      }

      const payload = {
        providerId: selectedOffer.offer.providerId,
        serviceId: selectedOffer.offer.category,
        serviceName: selectedOffer.offer.offerTitle,
        unitPrice: Number(selectedOffer.offer.price),
        startTime: convertOfferDateTimeToUTC(
          selectedOffer.offer.date,
          selectedOffer.offer.time
        ),
        roomId: selectedOffer.roomID,
        offerMessageId: selectedOffer._id,
        offerProviderName: selectedOffer.offer.providerName,
        duration: selectedOffer.offer.duration,
        paymentProfileId,
      };

      const res = await createJobFromOffer(payload);

      if (res?.data?.status) {
        toast.success("Job created successfully");
        setPaymentModal(false);

        setMessge((prevMessages) =>
          prevMessages.map((m) =>
            m._id === selectedOffer._id
              ? {
                ...m,
                offer: {
                  ...m.offer,
                  offerStatus: "accepted",
                  acceptedAt: new Date().toISOString(),
                },
              }
              : m
          )
        );
      } else {
        toast.error("Failed to create job");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to process offer");
    } finally {
      setLoadingOfferId(null);
    }
  };

  const formatTime = (time) => {
    if (!time) return "";

    // 1. Remove AM/PM completely
    const cleanTime = time.replace(/\s?(AM|PM)$/i, "").trim();

    const [hour, minute] = cleanTime.split(":").map(Number);
    if (isNaN(hour) || isNaN(minute)) return "";

    // 2. Create a UTC date (today's date, time from DB)
    const now = new Date();
    const utcDate = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        hour,
        minute
      )
    );

    // 3. Convert to Atlantic/Bermuda (12-hour)
    return utcDate.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: "Atlantic/Bermuda",
    });
  };

  const convertOfferDateTimeToUTC = (date, time) => {
    if (!date || !time) return null;

    const cleanTime = time.replace(/\s?(AM|PM)$/i, "");
    const [hour, minute] = cleanTime.split(":").map(Number);

    if (isNaN(hour) || isNaN(minute)) return null;

    const istDate = new Date(`${date}T${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:00+05:30`);

    return istDate.toISOString();
  };

  const formatOfferTimeToBermuda = (date, time) => {
    const utcTime = convertOfferDateTimeToUTC(date, time);
    if (!utcTime) return "";

    return new Date(utcTime).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: "Atlantic/Bermuda",
    });
  };

  return !props?.showChat?._id ? (
    <div className="chat-right"></div>
  ) : (
    <div className={`chat-right ${props.showChat?._id ? "show" : ""}`}>
      <div className="chat-header">
        <div className="contact-profile">
          <div className="back-btn">
            <BackIcon />
          </div>
          <div className="contact-profile-img-wrap">
            <div className="contact-profile-img">
              <img src={profileImage} alt="User" />
            </div>
          </div>
          <div className="contact-profile-name text-truncate">
            {getFullName(props?.showChat?.firstName, props?.showChat?.lastName)}
            {blockedStatusBySender?.length ? " has blocked you." : ""}
          </div>
        </div>
        <div className="dropdown-wrapper">
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <ul>
                <li>
                  <i>
                    <BlockIcon />
                  </i>
                  {blockedStatus?.length ? (
                    <span onClick={fetchUnblockUser}>Unblock</span>
                  ) : (
                    <span onClick={fetchBlockUser}>Block</span>
                  )}
                </li>
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="main-chat-area">
        <div className="chat-area" ref={scrollRef}>
          {message.map((msg, index) => {
            const isSender = id === msg?.senderID?._id;
            const offerDate = msg?.offer?.date;
            const offerPrice = msg?.offer?.price;
            const isButtonLoading = loadingOfferId === msg._id;
            const isOfferAccepted = msg?.offer?.offerStatus === "accepted";
            const isOfferPending = !msg?.offer?.offerStatus || msg.offer.offerStatus === "pending";
            const formattedDate = offerDate
            ? new Date(offerDate).toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
              year: "numeric",
            })
            : "";
            
            const formattedTime = formatOfferTimeToBermuda(
              msg?.offer?.date,
              msg?.offer?.time
            );
            return (
              <div
                className={isSender ? "sender" : "reciver"}
                key={index}
                onClick={() =>
                  msg?.type === "image" &&
                  openEnlargedView(fetchedImages[msg?._id])
                }
                style={{ cursor: msg?.type === "image" ? "pointer" : "" }}
              >
                <div
                  className={isSender ? "sender-message" : "reciver-message"}
                >
                  {msg?.type === "audio" && fetchedAudios[msg?._id] ? (
                    <audio
                      controls
                      controlsList="nodownload"
                      style={{ width: "300px" }}
                    >
                      <source src={fetchedAudios[msg?._id]} type="audio/webm" />
                      Your browser does not support the audio element.
                    </audio>
                  ) : msg?.type === "image" ? (
                    <img
                      src={fetchedImages[msg?._id]}
                      style={{ height: "300px", width: "300px" }}
                      alt="chat"
                    />
                  ) : msg?.type === "offer" && msg?.offer ? (
                    <div className="offer-card-wrapper">
                      <div className="offer-card">
                        {/* Header row */}
                        <div className="offer-header">
                          <h4>{msg.offer.providerName || msg.offer.offerTitle}</h4>

                          <div className="right-section">
                            <span className="rate">{msg.offer.rateType}</span>
                            <button
                              disabled={!isOfferPending || isButtonLoading}
                              className={`accept-btn ${isOfferAccepted ? "is-accepted" : ""
                                } ${isButtonLoading ? "is-disabled" : ""}`}
                              onClick={() => {
                                if (!isOfferPending || isButtonLoading) return;
                                handleAcceptOffer(msg);
                              }}
                            >
                              {isOfferAccepted
                                ? "Accepted"
                                : isButtonLoading
                                  ? "Accepting..."
                                  : "Accept Offer"}
                            </button>
                          </div>
                        </div>

                        {/* Details */}
                        <div className="offer-info">
                          <div className="item">
                            <MdCalendarToday className="icon" size={16} />{formattedDate}
                          </div>
                          <div className="item">
                            <MdAccessTime className="icon" size={16} />{formattedTime}
                          </div>
                          <div className="item">
                            <MdAttachMoney className="icon" size={16} />{offerPrice}
                          </div>
                        </div>

                        <div className="offer-footer">
                          <button
                            className="view-details-btn"
                            onClick={() => setSelectedOfferModal(msg)}
                          >
                            View Details
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    msg?.message
                  )}
                </div>
                <div className={isSender ? "sender-time" : "reciver-time"}>
                  {formatTime(msg?.createdAt)}
                </div>
              </div>
            );
          })}
        </div>

        <div className="chat-footer-area">
          <div className="chat-footer">
            {previewImage && (
              <div className="image-preview-box">
                <img
                  src={previewImage}
                  alt="preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
                <span
                  onClick={() => {
                    setPreviewImage(null);
                    setImageData(null);
                  }}
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontWeight: "bold",
                    marginLeft: "10px",
                  }}
                >
                  ✖
                </span>
              </div>
            )}
            {!previewImage && (
              <Form.Control
                as="textarea"
                value={input}
                disabled={
                  blockedStatus?.length || blockedStatusBySender?.length
                }
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={sendText}
                rows={3}
              />
            )}
            <div className="chat-footer-action">
              <div>
                <VoiceMsg
                  blocked={
                    blockedStatus?.length || blockedStatusBySender?.length
                  }
                  onAudioRecorded={async (fileOrAction) => {
                    if (fileOrAction === "send" && voiceNote) {
                      const mp3File = await convertToMp3(voiceNote)
                      const base64Audio = await audioBlobToBase64(mp3File);
                      sendVoiceMessage(base64Audio); // pass audio blob
                    } else if (fileOrAction instanceof File) {
                      setVoiceNote(fileOrAction); // store for later
                    }
                  }}
                />
              </div>
              <div className="attached-file">
                <AttachedIcon />
                <input
                  type="file"
                  accept="image/*"
                  disabled={
                    blockedStatus?.length || blockedStatusBySender?.length
                  }
                  onChange={handleFileChange}
                />
              </div>
              <div className="send-message">
                <Button
                  disabled={
                    blockedStatus?.length ||
                    blockedStatusBySender?.length ||
                    sendingImage
                  }
                  variant="primary"
                  type="submit"
                  onClick={sendMessage}
                >
                  <PapperBoatIcon />
                </Button>
              </div>
            </div>
          </div>
        </div>

        {enlargedImage && (
          <div className="enlarged-view-overlay" onClick={closeEnlargedView}>
            <div className="enlarged-view">
              <img
                src={enlargedImage}
                alt="Enlarged"
                className="enlarged-image"
              />
            </div>
          </div>
        )}

        {selectedOfferModal && (
          <div className="offer-modal-backdrop">
            <div className="offer-modal">

              {/* Header */}
              <div className="modal-header">
                <div className="header-text">
                  <h3 className="provider-name">
                    {selectedOfferModal.offer.providerName}
                  </h3>

                  {selectedOfferModal.offer.offerTitle && (
                    <p className="offer-title">
                      {selectedOfferModal.offer.offerTitle}
                    </p>
                  )}
                </div>

                <button
                  className="close-btn"
                  onClick={() => setSelectedOfferModal(null)}
                >
                  ✕
                </button>
              </div>

              {/* Description */}
              {selectedOfferModal.offer.description && (
                <p className="offer-description">
                  {selectedOfferModal.offer.description}
                </p>
              )}

              {/* Offer Meta */}
              <div className="offer-meta">
                <div className="meta-item">
                  <MdCalendarToday size={16} />
                  <span>
                    {new Date(selectedOfferModal.offer.date).toLocaleDateString(
                      "en-US",
                      { month: "long", day: "numeric", year: "numeric" }
                    )}
                  </span>
                </div>

                <div className="meta-item">
                  <MdAccessTime size={16} />
                    <span> {formatOfferTimeToBermuda(
                      selectedOfferModal.offer.date,
                      selectedOfferModal.offer.time
                    )}</span>
                </div>

                <div className="meta-item price">
                  <MdAttachMoney size={16} />
                  <span>{selectedOfferModal.offer.price}</span>
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <span className="rate-type">
                  {selectedOfferModal.offer.rateType}
                </span>

                <button
                  disabled={
                    loadingOfferId === selectedOfferModal?._id ||
                    selectedOfferModal?.offer?.offerStatus === "accepted"
                  }
                  className={`accept-btn
                    ${selectedOfferModal?.offer?.offerStatus === "accepted" ? "is-accepted" : ""}
                    ${loadingOfferId === selectedOfferModal?._id ? "is-disabled" : ""}
                  `}
                  onClick={() => {
                    if (
                      selectedOfferModal?.offer?.offerStatus === "accepted" ||
                      loadingOfferId === selectedOfferModal?._id
                    ) return;

                    handleAcceptOffer(selectedOfferModal);
                  }}
                >
                  {selectedOfferModal?.offer?.offerStatus === "accepted"
                    ? "Accepted"
                    : loadingOfferId === selectedOfferModal?._id
                      ? "Accepting..."
                      : "Accept Offer"}
                </button>
              </div>
            </div>
          </div>
        )}

        <CreateOfferPaymentModal
          paymentModal={paymentModal}
          setPaymentModal={setPaymentModal}
          onCardSelect={handleCardSelected}
          onCancel={handleCancelPayment}
        />
      </div>
    </div>
  );
};

export default Newchat;
